import React, { FC, useState } from 'react'
import { UnstyledButton, UnstyledButtonProps } from "@mantine/core"

interface MenuDropdownButtonProps extends UnstyledButtonProps {
  children: React.ReactNode
}

export const MenuDropdownButton: FC<MenuDropdownButtonProps> = ({ children, ...rest }) => {
  const [hovered, setHovered] = useState(false)
  return (
    <UnstyledButton
      {...rest}
      c='#0fb2f6'
      p='3px 1rem'
      fw={hovered ? '500' : '400'}
      w='100%'
      bg={hovered ? 'gray.1' : 'inherit'}
      style={{ fontSize: '16px', width: '100%' }}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </UnstyledButton>
  )
}
